import type { PostRegisterRequest } from './types';
import type { GetRegisterResponse } from '../get';

import { postGenericEndpoint, type PostGenericEndpointParams } from './post.api';

export const postRegister = async ({ data, lang, token }: PostGenericEndpointParams<PostRegisterRequest>): Promise<GetRegisterResponse> => {
    return await postGenericEndpoint({
        data,
        lang,
        token,
        path: 'register',
    });
};